module.exports = __webpack_public_path__ + "img/2.17563071.png";